import { LocationDescriptor } from 'history';
import { Link as RouterLink } from 'react-router-dom';
import { IconLink } from '@rossum/ui/icons/tabler';
import { Chip, ChipProps, SvgIcon } from '@rossum/ui/material';
import { useIsFeatureEnabled } from '../../feature-enablement/featureEnablement';

export const LinkedQueuesChip = ({
  queues,
  isQueueLevel,
  size,
  to,
}: {
  queues: string[];
  isQueueLevel: boolean;
  size?: ChipProps['size'];
  to: LocationDescriptor<unknown>;
}) => {
  const ruleManagerEnabled = useIsFeatureEnabled('rule-manager');
  return ruleManagerEnabled && queues.length > 1 && !!isQueueLevel ? (
    <Chip
      size={size}
      component={RouterLink}
      to={to}
      onClick={e => {
        e.stopPropagation();
      }}
      icon={
        <SvgIcon fontSize="large">
          <IconLink />
        </SvgIcon>
      }
      label={queues.length}
    />
  ) : null;
};
